// extracted by mini-css-extract-plugin
module.exports = {"red_color":"EmployeeSelection_red_color__2ggKa","black_color":"EmployeeSelection_black_color__2JWsD"};